import {initialState as auth} from "../reducers/auth";
import {initialState as utils} from "../reducers/utils";
import {initialState as languages} from "../reducers/languages";
import {initialState as users} from "../reducers/users";
import {initialState as reviews} from "../reducers/reviews";
import {initialState as moderators} from "../reducers/moderators";
import {initialState as staticTexts} from "../reducers/staticTexts";
import {initialState as media} from "../reducers/media";
import {initialState as composite} from "../reducers/composite";
import {initialState as filter} from "../reducers/filter";
import {initialState as category} from "../reducers/category";
import {initialState as product} from "../reducers/product";
import {initialState as order} from "../reducers/order";
import {initialState as slider} from "../reducers/slider";
import {initialState as badges} from "../reducers/badges";
import {initialState as status} from "../reducers/status";
import {initialState as partner} from "../reducers/partner";
import {initialState as banner} from "../reducers/banner";
import {initialState as section} from "../reducers/section";
import {initialState as promoCode} from "../reducers/promoCodes";
import {initialState as bonusCards} from "../reducers/bonusCards";
import {initialState as history} from "../reducers/history";
import {initialState as customPages} from "../reducers/customPages";
import {initialState as attributes} from "../reducers/attributes";
import {initialState as general} from "../reducers/general";
import {initialState as market} from "../reducers/market";
import {initialState as project} from "../reducers/project";
import {initialState as about} from "../reducers/about";
import {initialState as blogTypes} from "../reducers/blogTypes";
import {initialState as blogs} from "../reducers/blogs";
import {initialState as subscribers} from "../reducers/subscribers";
import {initialState as advertising} from "../reducers/advertising";
import {initialState as notifications} from "../reducers/notifications";
import {initialState as brandTypes} from "../reducers/brandTypes";
import {initialState as brand} from "../reducers/brand";


const reducers = {
    auth,
    utils,
    languages,
    users,
    reviews,
    moderators,
    staticTexts,
    media,
    composite,
    filter,
    category,
    product,
    order,
    slider,
    badges,
    status,
    partner,
    banner,
    section,
    promoCode,
    bonusCards,
    history,
    customPages,
    attributes,
    general,
    market,
    project,
    about,
    blogTypes,
    blogs,
    subscribers,
    advertising,
    notifications,
    brandTypes,
    brand
};

export default state => {
    const sData = {};
    Object.keys(reducers).forEach(selectorKey => {
        Object.keys(reducers[selectorKey]).forEach(key => {
            sData[key] = state[selectorKey][key];
        });
    });
    return sData;
};

